import './style.scss';

/**
 * #17989 - placeholder rows shown while a dashboard table is still loading, so the page
 * renders immediately after login instead of hiding behind the full-screen loading overlay.
 */
const TableSkeleton = ({ rows = 5, columns = 5, className = '' }) => {
    return (
        <div className={`table-skeleton ${className}`} aria-busy='true' aria-live='polite'>
            <div className='table-skeleton-row table-skeleton-header'>
                {Array.from({ length: columns }).map((_, colIdx) => (
                    <span key={`h-${colIdx}`} className='table-skeleton-cell' />
                ))}
            </div>
            {Array.from({ length: rows }).map((_, rowIdx) => (
                <div key={`r-${rowIdx}`} className='table-skeleton-row'>
                    {Array.from({ length: columns }).map((_, colIdx) => (
                        <span key={`c-${rowIdx}-${colIdx}`} className='table-skeleton-cell' />
                    ))}
                </div>
            ))}
        </div>
    );
};

export default TableSkeleton;
